import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetBoothDeviceCodeList: false,
  getBoothDeviceCodeListMessage: '',
  getBoothDeviceCodeListFailed: '',

  isLoadingGetDisuseBoothDeviceCode: false,
  getDisuseBoothDeviceCodeMessage: '',
  getDisuseBoothDeviceCodeFailed: '',

  isLoadingPostCreateBoothDeviceCode: false,
  postCreateBoothDeviceCodeMessage: '',
  postCreateBoothDeviceCodeFailed: '',

  isLoadingDeleteBoothDeviceCode: false,
  deleteBoothDeviceCodeMessage: '',
  deleteBoothDeviceCodeFailed: '',

  isLoadingUpdateBoothDeviceCodeName: false,
  updateBoothDeviceCodeNameMessage: '',
  updateBoothDeviceCodeNameFailed: '',
};

const initialState = JSON.parse(JSON.stringify(state));

function boothDeviceCodeReducer(globalstate = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialState,
      };
    case actionTypes.GET_BOOTH_DEVICE_CODE_LIST_PENDING:
      return {
        ...globalstate,
        isLoadingGetBoothDeviceCodeList: true,
      };
    case actionTypes.GET_BOOTH_DEVICE_CODE_LIST_FULFILLED:
      return {
        ...globalstate,
        isLoadingGetBoothDeviceCodeList: false,
        getBoothDeviceCodeListMessage: action.data,
        getBoothDeviceCodeListFailed: '',
      };
    case actionTypes.GET_BOOTH_DEVICE_CODE_LIST_FAILURE:
      return {
        ...globalstate,
        isLoadingGetBoothDeviceCodeList: false,
        getBoothDeviceCodeListMessage: '',
        getBoothDeviceCodeListFailed: action.error,
      };
    case actionTypes.GET_DISUSE_BOOTH_DEVICE_CODE_PENDING:
      return {
        ...globalstate,
        isLoadingGetDisuseBoothDeviceCode: true,
      };
    case actionTypes.GET_DISUSE_BOOTH_DEVICE_CODE_FULFILLED:
      return {
        ...globalstate,
        isLoadingGetDisuseBoothDeviceCode: false,
        getDisuseBoothDeviceCodeMessage: action.data,
        getDisuseBoothDeviceCodeFailed: '',
      };
    case actionTypes.GET_DISUSE_BOOTH_DEVICE_CODE_FAILURE:
      return {
        ...globalstate,
        isLoadingGetDisuseBoothDeviceCode: false,
        getDisuseBoothDeviceCodeMessage: '',
        getDisuseBoothDeviceCodeFailed: action.error,
      };
    case actionTypes.POST_CREATE_BOOTH_DEVICE_CODE_PENDING:
      return {
        ...globalstate,
        isLoadingPostCreateBoothDeviceCode: true,
      };
    case actionTypes.POST_CREATE_BOOTH_DEVICE_CODE_FULFILLED:
      return {
        ...globalstate,
        isLoadingPostCreateBoothDeviceCode: false,
        postCreateBoothDeviceCodeMessage: action.data,
        postCreateBoothDeviceCodeFailed: '',
      };
    case actionTypes.POST_CREATE_BOOTH_DEVICE_CODE_FAILURE:
      return {
        ...globalstate,
        isLoadingPostCreateBoothDeviceCode: false,
        postCreateBoothDeviceCodeMessage: '',
        postCreateBoothDeviceCodeFailed: action.error,
      };
    case actionTypes.DELETE_BOOTH_DEVICE_CODE_PENDING:
      return {
        ...globalstate,
        isLoadingDeleteBoothDeviceCode: true,
      };
    case actionTypes.DELETE_BOOTH_DEVICE_CODE_FULFILLED:
      return {
        ...globalstate,
        isLoadingDeleteBoothDeviceCode: false,
        deleteBoothDeviceCodeMessage: action.data,
        deleteBoothDeviceCodeFailed: '',
      };
    case actionTypes.DELETE_BOOTH_DEVICE_CODE_FAILURE:
      return {
        ...globalstate,
        isLoadingDeleteBoothDeviceCode: false,
        deleteBoothDeviceCodeMessage: '',
        deleteBoothDeviceCodeFailed: action.error,
      };
    case actionTypes.UPDATE_BOOTH_DEVICE_CODE_NAME_PENDING:
      return {
        ...globalstate,
        isLoadingUpdateBoothDeviceCodeName: true,
      };
    case actionTypes.UPDATE_BOOTH_DEVICE_CODE_NAME_FULFILLED:
      return {
        ...globalstate,
        isLoadingUpdateBoothDeviceCodeName: false,
        updateBoothDeviceCodeNameMessage: action.data,
        updateBoothDeviceCodeNameFailed: '',
      };
    case actionTypes.UPDATE_BOOTH_DEVICE_CODE_NAME_FAILURE:
      return {
        ...globalstate,
        isLoadingUpdateBoothDeviceCodeName: false,
        updateBoothDeviceCodeNameMessage: '',
        updateBoothDeviceCodeNameFailed: action.error,
      };
    default:
      return globalstate;
  }
}

export { boothDeviceCodeReducer as default };
